<template>
    <q-page class="public-view q-pb-md form">
        <!-- guide text -->
        <q-card-section>
            <p class="form__message">
                {{ $t('Enter your e-mail to reset your password') }}.
            </p>
        </q-card-section>
        <!-- Form Body -->
        <q-card-section>
            <q-form
                @submit="handleSubmit"
                ref="loginForm"
                :class="$q.platform.is.ipad ? 'ios-form' : 'q-pt-md q-px-md'"
            >
                <q-input
                    class="q-mb-md"
                    outlined
                    lazy-rules
                    for="email-field"
                    v-model="form.email"
                    :label="$t('Email')"
                    :rules="[validateEmail]"
                    color="accent"
                />

                <q-btn
                    :label="$t('Submit')"
                    id="submit-button"
                    style="width: 100%"
                    type="submit"
                    color="primary"
                />

                <q-btn
                    class="q-mt-md"
                    @click="$router.push({ name: 'login' })"
                    :label="$t('Return to login')"
                    id="return-button"
                    style="width: 100%"
                    text-color="primary"
                    color="white"
                    outline
                />
            </q-form>
        </q-card-section>
    </q-page>
</template>

<script>
import { mapActions } from 'pinia';
import { useSharedStore } from '@stores/shared.js';
import { useAuthStore } from '@stores/auth';

export default {
    name: 'ResetPassword',
    data() {
        return {
            form: {
                email: ''
            }
        };
    },
    methods: {
        ...mapActions(useSharedStore, ['beginLoading', 'stopLoading']),
        ...mapActions(useAuthStore, ['resetPasswordAction']),
        /**
         * Validate e-mail input.
         * @param {string} input - User's email.
         * @returns {(string|void)} - Error message.
         */
        validateEmail(input) {
            if (input === '') {
                return this.$t('Enter your e-mail');
            } else {
                // check if pattern is anystring@anystring.anystring
                const re = /\S+@\S+\.\S+/;
                if (!re.test(input)) {
                    return this.$t('Enter a valid e-mail');
                }
            }
        },
        /**
         * Handles reset password submission.
         */
        async handleSubmit() {
            // begin loading
            this.beginLoading(`${this.$t('Sending request')}...`);

            // dispatch action
            try {
                await this.resetPasswordAction(this.form.email);
                // The API returns 204 regardless of whether the
                // email is found or not.
                this.$notifySuccess(
                    this.$t(
                        'If this email address is used, we will send you an email to reset your password.'
                    )
                );
            } catch (error) {
                this.$notifyError(
                    this.$t(
                        'An error occurred while trying to reset your password.'
                    ),
                    error
                );
            } finally {
                // stop loading
                this.stopLoading();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@css/auth_forms.scss';
.form {
    width: 400px;
}
</style>
